import React from "react";
import {useDispatch} from 'react-redux';
import { openOrderSafeCallModal } from "../../../../../../redux/actions/modals";
const SafeCallComponent = (props) => {
  const {order} = props;
  const dispatch = useDispatch();
  return (
    <button 
      className="btn btn-small btn-outline-primary margin-bottom-5"
      onClick={() => dispatch(openOrderSafeCallModal(order))}
    >
      تماس امن با کاربر
    </button>
  );
};

export default SafeCallComponent;
